import s from './CustomPreloader.module.css';

export const CustomPreloader = (): JSX.Element => {
  return (
    <svg
      width="180"
      height="62"
      viewBox="0 0 180 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={s.customPreloader}
    >
      <g clipPath="url(#clip0_10785_68483)">
        <path
          d="M23.9317 -0.0234375C22.2176 -0.0234375 20.6057 0.79328 19.5955 2.17955L0.805691 27.89C-0.575204 29.776 -0.575204 32.3443 0.805691 34.2303L19.5955 59.9407C20.6057 61.327 22.2176 62.1437 23.9317 62.1437H90.0696V-0.0234375H23.9317Z"
          fill="#14088C"
        />
        <path
          d="M155.966 -0.0234375C157.68 -0.0234375 159.292 0.79328 160.302 2.17955L179.092 27.89C180.473 29.776 180.473 32.3443 179.092 34.2303L160.302 59.9407C159.292 61.327 157.68 62.1437 155.966 62.1437H89.8279V-0.0234375H155.966Z"
          fill="#14088C"
        />
        <mask
          id="mask0_10785_68483"
          style={{maskType: 'luminance'}}
          maskUnits="userSpaceOnUse"
          x="-1"
          y="-1"
          width="182"
          height="64"
        >
          <path
            d="M179.098 27.89L160.308 2.17955C159.298 0.79328 157.686 -0.0234375 155.972 -0.0234375H23.9375C22.2235 -0.0234375 20.6115 0.79328 19.6014 2.17955L0.81155 27.89C-0.569345 29.776 -0.569345 32.3443 0.81155 34.2303L19.6014 59.9407C20.6115 61.327 22.2235 62.1437 23.9375 62.1437H155.972C157.686 62.1437 159.298 61.327 160.308 59.9407L179.098 34.2303C180.478 32.3443 180.478 29.776 179.098 27.89Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_10785_68483)">
          <path
            d="M27.8433 74.0439L-3.11133 31.0642L27.8433 -11.9209L58.7979 31.0588L27.8433 74.0385V74.0439Z"
            fill="#26A949"
          />
          <path d="M89.7476 74.0434L58.793 31.0637L89.7476 -11.916L120.702 31.0637L89.7476 74.0434Z" fill="#26A949" />
          <path d="M151.651 74.0434L120.696 31.0637L151.651 -11.916L182.606 31.0637L151.651 74.0434Z" fill="#26A949" />
          <path d="M71.5591 31.0595L89.86 5.64453L108.161 31.0595L89.86 56.4798L71.5591 31.0595Z" fill="#FFC01D" />
          <path
            d="M89.7472 12.6455L92.5198 28.2867L108.161 31.0592L92.5198 33.8371L89.7472 49.4783L86.9693 33.8371L71.3281 31.0592L86.9693 28.2867L89.7472 12.6455Z"
            fill="#FFECA6"
          />
          <path
            d="M99.204 21.6016L95.5234 31.0583L99.204 40.5204L89.7472 36.8398L80.2905 40.5204L83.9711 31.0583L80.2905 21.6016L89.7472 25.2822L99.204 21.6016Z"
            fill="#FFECA6"
          />
          <path d="M9.53711 31.0595L27.8434 5.64453L46.1443 31.0595L27.8434 56.4798L9.53711 31.0595Z" fill="#FFC01D" />
          <path d="M133.35 31.0595L151.651 5.64453L169.952 31.0595L151.651 56.4798L133.35 31.0595Z" fill="#FFC01D" />
          <path
            d="M160.963 31.0582L154.895 33.726L152.224 39.7968L149.556 33.7286L143.488 31.0608L149.559 28.3905L152.227 22.3223L154.895 28.3905L160.963 31.0582Z"
            fill="#FFECA6"
          />
          <path
            d="M36.9625 31.5231L30.8943 34.1908L28.224 40.2616L25.5562 34.1934L19.488 31.5257L25.5588 28.8553L28.2266 22.7871L30.8943 28.8553L36.9625 31.5231Z"
            fill="#FFECA6"
          />
          <path
            d="M120.863 -17.5518L123.507 -2.6628L138.39 -0.0245933L123.507 2.61899L120.863 17.5026L118.225 2.61899L103.336 -0.0245933L118.225 -2.6628L120.863 -17.5518Z"
            fill="#FFECA6"
          />
          <path
            d="M120.863 44.6211L123.507 59.5047L138.39 62.1483L123.507 64.7865L120.863 79.6754L118.225 64.7865L103.336 62.1483L118.225 59.5047L120.863 44.6211Z"
            fill="#26A949"
          />
          <path
            d="M58.1265 -17.5518L60.7701 -2.6628L75.6537 -0.0245933L60.7701 2.61899L58.1265 17.5026L55.4883 2.61899L40.5994 -0.0245933L55.4883 -2.6628L58.1265 -17.5518Z"
            fill="#26A949"
          />
          <path
            d="M58.1265 44.6211L60.7701 59.5047L75.6537 62.1483L60.7701 64.7865L58.1265 79.6754L55.4883 64.7865L40.5994 62.1483L55.4883 59.5047L58.1265 44.6211Z"
            fill="#FFECA6"
          />
          <g style={{mixBlendMode: 'overlay'}}>
            <rect
              width="680.22"
              height="429.911"
              transform="matrix(0.0119557 -0.999929 -0.999929 -0.0119557 355.09 494.435)"
              fill="url(#pattern0_10785_68483)"
              fillOpacity="0.5"
            />
          </g>
          <g style={{mixBlendMode: 'screen'}}>
            <rect
              x="0.12915"
              y="-0.0634766"
              width="287.798"
              height="97.9416"
              fill="url(#pattern1_10785_68483)"
              fillOpacity="0.2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
